/* Publish by EComposer at 2026-09-26 19:49:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2umuj5ger0p"]=  window.__ectimmers["ecom-2umuj5ger0p"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-2umuj5ger0p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2umuj5ger0p', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-p8s1yoi70tq"]=  window.__ectimmers["ecom-p8s1yoi70tq"] || {};


                    });
                    
                        document.querySelectorAll('.ecom-p8s1yoi70tq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p8s1yoi70tq', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qhb4k2145f"]=  window.__ectimmers["ecom-qhb4k2145f"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-qhb4k2145f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhb4k2145f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n60eundcj1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n60eundcj1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}